import { render, staticRenderFns } from "./Periodos.vue?vue&type=template&id=d36e0ad2&scoped=true"
import script from "./Periodos.vue?vue&type=script&lang=js"
export * from "./Periodos.vue?vue&type=script&lang=js"
import style0 from "./Periodos.vue?vue&type=style&index=0&id=d36e0ad2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d36e0ad2",
  null
  
)

export default component.exports